export const hoverColor = '#F5FCFF';

export const activeColor = '#CCEAFF';
